import { render, staticRenderFns } from "./parentMessage.vue?vue&type=template&id=c3124880&scoped=true"
import script from "./parentMessage.vue?vue&type=script&lang=js"
export * from "./parentMessage.vue?vue&type=script&lang=js"
import style0 from "./parentMessage.vue?vue&type=style&index=0&id=c3124880&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3124880",
  null
  
)

export default component.exports